export default __webpack_public_path__ + "static/media/RoundUp_App.63e0dbc6.png";